module.exports = __webpack_public_path__ + "static/media/google.9b224c98.png";